import {
  HC_TOPICS_TO_DISCUSS_OPTIONS,
  LC_TOPICS_TO_DISCUSS_OPTIONS,
  ReasonForRegistering,
} from "@Roo/constants/checkBoxConstants";
import { WhyAreYouOnRoo } from "@Roo/api/vet";
import { patchVet } from "@Roo/api/vet/patchVet";

import { useRedirect } from "../Common/hooks/useRedirect";
import { useRegistrationContext } from "../Common/registrationContext";

export const useValidate = () => {
  const validate = (form: WhyAreYouOnRoo) => {
    const errors: {
      reasonForRegistering?: string;
    } = {};
    if (!form.reasonForRegistering) {
      errors.reasonForRegistering = "This field is required";
    }

    return errors;
  };
  return { validate };
};

export const useSave = () => {
  const { redirectToVetPreferences } = useRedirect();
  const { registrationContext, setRegistrationContext } = useRegistrationContext();
  const { userId, entityId } = registrationContext;

  const save = async (form: WhyAreYouOnRoo): Promise<void> => {
    const highCommitment = form.reasonForRegistering === ReasonForRegistering.FindingTheRightShift;

    const topicsToDiscuss = highCommitment
      ? HC_TOPICS_TO_DISCUSS_OPTIONS
      : LC_TOPICS_TO_DISCUSS_OPTIONS;

    setRegistrationContext({
      registrationContext: {
        ...registrationContext,
        ...form,
        topicsToDiscuss: topicsToDiscuss.map((option) => ({
          ...option,
          checked: false,
        })),
      },
    });

    const vetData: any = {
      userId: userId,
      vetId: entityId,
      reasonForRegistering: form.reasonForRegistering,
    };
    await patchVet(vetData);

    redirectToVetPreferences({ highCommitment });
  };
  return { save };
};
